import { useGetAdminIsAuthenticated } from '@sit/client-shared';
import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import Spinner from '../Spinner';

const SamlProtectedRoute = ({ children }: { children: ReactNode }) => {
  const { isPending, isError } = useGetAdminIsAuthenticated();
  const { pathname } = useLocation();
  if (isPending) return <Spinner />;

  if (isError) return <Navigate to="/saml" state={{ initialUrl: pathname }} />;
  return children;
};

export default SamlProtectedRoute;
